export type Category = {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
};

export const categories: Category[] = [
  {
    id: "live",
    name: "直播圈",
    icon: "ri-live-line",
    desc: "排期、开播预告与直播间里的即时讨论，按场次归拢脉络。",
    count: 286,
  },
  {
    id: "short",
    name: "短视频",
    icon: "ri-play-circle-line",
    desc: "二创标注、内容规范与热门视频背后的创作过程。",
    count: 342,
  },
  {
    id: "commerce",
    name: "电商带货",
    icon: "ri-shopping-bag-3-line",
    desc: "优惠机制、专场节奏与售后公告的公开信息梳理。",
    count: 198,
  },
  {
    id: "variety",
    name: "综艺娱乐",
    icon: "ri-movie-2-line",
    desc: "版本差异、剪辑说明与节目运营节奏的观察记录。",
    count: 174,
  },
  {
    id: "social",
    name: "社交平台",
    icon: "ri-chat-smile-2-line",
    desc: "账号安全、推荐机制与平台规则更新的讨论存档。",
    count: 156,
  },
  {
    id: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    desc: "演出顺序、现场体验与活动信息同步的整理。",
    count: 124,
  },
];

export const categoryById = (id: string): Category | undefined =>
  categories.find((c) => c.id === id);

export const siteStats = [
  { value: "1,280+", label: "收录事件档案", icon: "ri-archive-2-line" },
  { value: "6", label: "内容分类", icon: "ri-layout-grid-line" },
  { value: "24", label: "小时持续更新", icon: "ri-time-line" },
  { value: "5.2万", label: "网友参与讨论", icon: "ri-chat-3-line" },
];

export const hotSearch = [
  { rank: 1, title: "深夜直播临时改档说明", heat: "982.1万", tag: "新" },
  { rank: 2, title: "短视频二创标注规范讨论", heat: "863.4万", tag: "热" },
  { rank: 3, title: "带货专场优惠叠加示意更新", heat: "774.2万", tag: "" },
  { rank: 4, title: "综艺正片与加更版差异", heat: "651.0万", tag: "" },
  { rank: 5, title: "账号安全提示上线", heat: "589.0万", tag: "" },
  { rank: 6, title: "音乐节时间表更新说明", heat: "492.0万", tag: "" },
  { rank: 7, title: "组合后续安排以官宣为准", heat: "438.0万", tag: "" },
  { rank: 8, title: "联名周边下架公告", heat: "396.0万", tag: "" },
];